function isArrayBuffer(object: unknown): object is ArrayBuffer {
    try {
        return object instanceof ArrayBuffer || object instanceof Buffer;
    } catch (error) {
        /* Buffer|ArrayBuffer definitions missing (running in Browser?) */
        return false;
    }
}

function arrayBufferToString(buffer: ArrayBuffer): string {
    const result = new TextDecoder().decode(buffer);
    return result;
}

function stringToArrayBuffer(str: string): ArrayBuffer {
    const byteArray = new TextEncoder().encode(str);
    const buffer = byteArray.buffer;
    return buffer;
}

const module = {
    arrayBufferToString,
    stringToArrayBuffer,
    isArrayBuffer,
};

export default module;
